/// <reference path="../../BaseNew/GAdmSeznamBase.ts"/>

namespace Gordic.Adm.WebControls {
    @Decorators.gcontent
    export class SeznamAdmProfilVlastnosti extends GContentBase<SeznamAdmProfilVlastnostiObj> {
        private seznamObj: SeznamAdmProfilVlastnostiObj & GContent;

        onContentReady() {
            this.seznamObj = $.extend(this as GContent, new SeznamAdmProfilVlastnostiObj());
            this.seznamObj.createBase({
                content: this,
                contentName: "seznamAdmProfilVlastnosti",
                contentCaption: "jres:33000460", //RC 33000460 : Profily vlastnost�
                dataListDescriptor: this.dataListDescription,
                comparatorSettings: {
                    itemTemplate: "{ixs_pro}"
                },
                gridSettings: {
                    columnOrder: "kod,nazev,zkratka,ixs_pro,dat_zmena,zmenu_provedl,priz_ixs_rpp"
                }
            })
            this.seznamObj.createBaseMenuBarActions();
            this.seznamObj.createFilter();
            this.seznamObj.createGrid();
        }
    }

    export class SeznamAdmProfilVlastnostiObj extends GAdmSeznamBase {
        private srv;

        private getSrv(): GContent {
            if (this.srv == null || this.srv == undefined)
                this.srv = this.cnt.createServiceContent("Gordic.Adm.WebControls.SeznamAdmProfilVlastnosti");
            return this.srv;
        }


        create() {

        }

        openDetail(data: any, isNew: boolean) {
            $.content().navigate(["Gordic.Adm.WebControls.DetailAdmProfilVlastnosti", {
                currentFilter: this.filterData,
                gridRc: new Gordic.Components.GridRC(this.grid)
            }], {
                ID: "DetailAdmProfilVlastnosti",
                newRecord: isNew,
                ixs_pro: isNew == true ? null : data.ixs_pro
            })
        }

        createActions(): { [akceName: string]: GAction | GActionParamsDefObj } | null {
            return {
                actOpenSeznamAdmProfilObjekt: {
                    icon: "fa-link",
                    caption: "jres:33000466",
                    run: () => {
                        this.openSeznamAdmProfilObjekt();
                    }
                },
                actOpenHromadnePridaniProfilyTypObjektu: {
                    icon: "fa-link",
                    caption: "jres:33000500", 
                    run: () => {
                        this.openHromadnePridaniProfilyTypObjektu();
                    }
                },
                actOpenSeznamAdmVlastnostTypDokumentu: {
                    icon: "fa-link",
                    caption: "jres:33000477", //RC 33000477 : Nav�zan� typy dokument�
                    tooltip: "jres:33000510",
                    run: () => {
                        this.openSeznamAdmVlastnostTypDokumentu()
                    }
                },
                actOpenHromadnePridaniVlastnostTypDokumentu: {
                    icon: "fa-link",
                    caption: "jres:33000513", //RC 33000513 : P�i�adit p�eddefinovan� hromadn�
                    run: () => {
                        this.openHromadnePridaniVlastnostTypDokumentu();
                    }
                },
                actGenerCodeIFEmpty: {
                    icon: "gi-settings",
                    caption: "jres:33000536", //RC 33000536 : Vygenerovat k�dy
                    tooltip: "jres:33000538", //RC 33000538 : Dogeneruje v�echny k�dy pokud nejsou ��dn� nenalezne
                    run: () => {
                        this.generCodeAutomaticky();
                    }
                }
            }
        }

        createBaseMenuBarActions() {
            this.cnt.menuBar(this.cnt.actions.createBar(["actOpenDetail*", "actNewDetail*", "actAddToComparison", "actOpenDialogVyberovaSkupina", "actGenerCodeIFEmpty", {
                type: "static", caption: "jres:33000138", icon: "fa-link", favorite: true, children: [
                    {
                        type: "static", caption: "jres:33000485", icon: "fa-link", children: [
                            { action: this.cnt.actions.actOpenSeznamAdmProfilObjekt },
                            { action: this.cnt.actions.actOpenHromadnePridaniProfilyTypObjektu },
                        ]
                    },
                    {
                        action: this.cnt.actions.actOpenSeznamAdmVlastnostTypDokumentu,
                        children: [
                            { action: this.cnt.actions.actOpenHromadnePridaniVlastnostTypDokumentu }
                        ]
                    }
                ]
            }]))
        }

        createContextMenu(): MenuParams[] {
            return this.cnt.actions.createBar([
                "actOpenDetail*",
                {
                    type: "static", caption: "jres:33000485", icon: "fa-link", children: [
                        { action: this.cnt.actions.actOpenSeznamAdmProfilObjekt },
                        { action: this.cnt.actions.actOpenHromadnePridaniProfilyTypObjektu },
                    ]
                },
                {
                    action: this.cnt.actions.actOpenSeznamAdmVlastnostTypDokumentu,
                    children: [
                        { action: this.cnt.actions.actOpenHromadnePridaniVlastnostTypDokumentu }
                    ]
                }
                ])
        }

        createFilterForm() {

        }

        userhardDefaultFilter(hardFilter: any): any {
            return hardFilter;
        }

        collectData(data: any) {

        }

        applydata(filterData: any) {
            this.cnt.isl.AdmProfilVlastnosti.list({ filters: filterData }).getView().done((data) => {
                this.view = data;
                this.grid.ggrid('setData', this.view);
            });
        }

        selectionGridAct(objArr: IGGridSelection<any>) {
            this.cnt.actions.actOpenSeznamAdmProfilObjekt?.update({ enabled: objArr.count == 1 })
            this.cnt.actions.actOpenSeznamAdmVlastnostTypDokumentu?.update({ enabled: objArr.count == 1 })
        }

        getSxs(data): IGAdmGridSxs {
            return {
                sxs: "{0}".format(data.ixs_pro),
                nazev: data["nazev"]
            }
        }

        private openHromadnePridaniProfilyTypObjektu() {
            var selectionData = this.grid.ggrid("getSelection");
            var data: Gordic.AdmIsl.Interface.GAdmVlastnostTypObjektuListDto[] = [];
            if (selectionData.length > 0) {
                selectionData.forEach((item) => {
                    data.push({
                        ixs: item["ixs_pro"],
                        ixs_txt: item["nazev"],
                        typ_vps_txt: "jres:33000460",
                        typ_vps: 0
                    })
                })
            }
            this.cnt.dialogs.showModalWindow(["Gordic.Adm.WebControls.HromadnaOperaceAdmVlastnostTypObjektu"], { ID: "HromadnaOperaceAdmVlastnostTypObjektu", data: data }, "", 1000, 600)
        }

        private openHromadnePridaniVlastnostTypDokumentu() {
            var selectionData = this.grid.ggrid("getSelection");
            var data: Gordic.AdmIsl.Interface.GAdmVlastnostTypDokumentuReadDto[] = [];
            if (selectionData.length > 0) {
                selectionData.forEach((item) => {
                    data.push({
                        ixs: item["ixs_pro"],
                        typ_vps: 0
                    })
                })
            }
            this.cnt.dialogs.showModalWindow(["Gordic.Adm.WebControls.HromadnaOperaceVlastnostTypDokumentu"], { ID: "HromadnaOperaceVlastnostTypDokumentu", data: data }, "", 1000, 600)
        }

        private openSeznamAdmProfilObjekt() {
            var activeRow = this.grid.ggrid("activeRow");
            if (activeRow) {
                this.cnt.navigate(["Gordic.Adm.WebControls.SeznamAdmVlastnostTypObjektu"], {
                    Id: "SeznamAdmVlastnostTypObjektu",
                    typ_vps: 0,
                    ixs: activeRow.ixs_pro
                })
            }
        }

        private openSeznamAdmVlastnostTypDokumentu() {
            var activeRow = this.grid.ggrid("activeRow");
            if (activeRow) {
                this.cnt.navigate(["Gordic.Adm.WebControls.SeznamAdmVlastnostTypDokumentu"], {
                    Id: "SeznamAdmVlastnostTypDokumentu",
                    typ_vps: 0,
                    ixs: activeRow.ixs_pro
                })
            }
        }

        private generCodeAutomaticky() {
            this.getSrv().call("CheckCodeProfiles").done((output) => {
                this.cnt.notification("showToast", {
                    title: "jres:33000460",
                    content: "jres:33000537".format(output.sucessItemsCount, output.errorItemsCount), //RC 33000537 : �sp�n� dogenerov�no: {0} ; Ne�sp�n� dogenerov�no: {1}
                    icon: "fa-info-circle",
                    state: "info"
                });
            })
        }
    }
}
